import { render, staticRenderFns } from "./repage.vue?vue&type=template&id=6457d401&scoped=true&"
import script from "./repage.vue?vue&type=script&lang=js&"
export * from "./repage.vue?vue&type=script&lang=js&"
import style0 from "./repage.vue?vue&type=style&index=0&id=6457d401&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6457d401",
  null
  
)

export default component.exports